import { useState, useEffect } from "react";

// Hook personalizado para detectar dispositivos móviles
export const useMobileDetector = () => {
  const detectDevice = () => {
    if (typeof window === "undefined") {
      return { mobile: false, device: "Desktop" };
    }
    const userAgent = navigator.userAgent.toLowerCase();
    const screenWidth = window.innerWidth;

    // Detección por User Agent
    const mobileRegex =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    const isMobileUA = mobileRegex.test(userAgent);

    // Detección por ancho de pantalla
    const isMobileScreen = screenWidth <= 768;

    // Detección específica de dispositivos
    let device = "Desktop";
    if (/iphone/i.test(userAgent)) device = "iPhone";
    else if (/ipad/i.test(userAgent)) device = "iPad";
    else if (/android/i.test(userAgent)) device = "Android";
    else if (/blackberry/i.test(userAgent)) device = "BlackBerry";
    else if (isMobileScreen) device = "Mobile";

    return { mobile: isMobileUA || isMobileScreen, device };
  };

  // Inicializar sin parpadeo: calcular en el primer render
  const initial = detectDevice();
  const [isMobile, setIsMobile] = useState(initial.mobile);
  const [deviceType, setDeviceType] = useState(initial.device);

  useEffect(() => {
    const onResize = () => {
      const { mobile, device } = detectDevice();
      setIsMobile(mobile);
      setDeviceType(device);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return { isMobile, deviceType };
};

// Función utilitaria independiente
export const detectMobileDevice = () => {
  if (typeof window === "undefined") return false;

  const userAgent = navigator.userAgent.toLowerCase();
  const mobileRegex =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  const screenWidth = window.innerWidth;

  return mobileRegex.test(userAgent) || screenWidth <= 768;
};

// // Componente de demostración
// const MobileDetectorDemo = () => {
//     const { isMobile, deviceType } = useMobileDetector();
//     const [screenSize, setScreenSize] = useState({ width: 0, height: 0 });

//     useEffect(() => {
//         const updateScreenSize = () => {
//             setScreenSize({
//                 width: window.innerWidth,
//                 height: window.innerHeight
//             });
//         };

//         updateScreenSize();
//         window.addEventListener('resize', updateScreenSize);

//         return () => window.removeEventListener('resize', updateScreenSize);
//     }, []);

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
//             <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
//                 <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6">
//                     <h1 className="text-2xl font-bold text-white text-center">
//                         Detector de Móvil
//                     </h1>
//                 </div>

//                 <div className="p-6 space-y-4">
//                     {/* Estado principal */}
//                     <div className="text-center">
//                         <div className={`inline-flex items-center px-4 py-2 rounded-full text-lg font-semibold ${isMobile
//                             ? 'bg-green-100 text-green-800'
//                             : 'bg-red-100 text-red-800'
//                             }`}>
//                             {isMobile ? '📱 Es Móvil' : '🖥️ Es Desktop'}
//                         </div>
//                     </div>

//                     {/* Información del dispositivo */}
//                     <div className="bg-gray-50 rounded-lg p-4">
//                         <h3 className="font-semibold text-gray-700 mb-2">Información del Dispositivo:</h3>
//                         <div className="space-y-2 text-sm">
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Tipo:</span>
//                                 <span className="font-medium">{deviceType}</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Ancho:</span>
//                                 <span className="font-medium">{screenSize.width}px</span>
//                             </div>
//                             <div className="flex justify-between">
//                                 <span className="text-gray-600">Alto:</span>
//                                 <span className="font-medium">{screenSize.height}px</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* User Agent */}
//                     <div className="bg-gray-50 rounded-lg p-4">
//                         <h3 className="font-semibold text-gray-700 mb-2">User Agent:</h3>
//                         <p className="text-xs text-gray-600 break-all">
//                             {typeof window !== 'undefined' ? navigator.userAgent : 'N/A'}
//                         </p>
//                     </div>

//                     {/* Métodos de detección */}
//                     <div className="bg-blue-50 rounded-lg p-4">
//                         <h3 className="font-semibold text-blue-700 mb-2">Métodos de Detección:</h3>
//                         <div className="space-y-1 text-sm">
//                             <div className="flex items-center">
//                                 <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
//                                 <span>User Agent Pattern</span>
//                             </div>
//                             <div className="flex items-center">
//                                 <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
//                                 <span>Ancho de Pantalla ≤ 768px</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Instrucciones de uso */}
//                     <div className="bg-yellow-50 rounded-lg p-4">
//                         <h3 className="font-semibold text-yellow-700 mb-2">Cómo usar:</h3>
//                         <div className="text-sm text-yellow-600 space-y-1">
//                             <p>• Hook: <code className="bg-yellow-200 px-1 rounded">useMobileDetector()</code></p>
//                             <p>• Función: <code className="bg-yellow-200 px-1 rounded">detectMobileDevice()</code></p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MobileDetectorDemo;
